export class LoanChecklistModel {
  quoteId: number;
  termsAndConditionsExplained: boolean = false;
  barcodedIdUploaded: boolean = false;
  debicheckSlipUploaded: boolean = false;
  accountNumbersMatch: boolean = false;
  myBenefitsTermsAccepted: boolean = false;
  annexureAReceived: boolean = false;
  reasonForFirstLoan: string = '';
  reasonForSecondLoan: string = '';
}
